/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, createContext, useContext, useState, useMemo } from 'react';
import { IUserInfo, IUserProcess, UserProcessStep } from '@common/interfaces';

const initialState = {
  userInfo: {
    email: '',
    firstName: '',
    lastName: '',
  },
  userProcess: {
    businessInfo: {
      address: '',
      city: '',
      countryCode: '',
      organizationName: '',
      phoneNumber: '',
    },
    id: '',
    rfp: '',
    state: '',
    updated: '',
    country_of_operation_name: '',
    agency_complete_name: '',
    country_of_operation_iso_code: '',
    agency_id_on_UNBH: '',
    agency_short_name: '',
    organisation_category_name: '',
    organisation_category_id_on_UNBH: '',
    userStep: UserProcessStep.business_info,
  },
  setUserInfo: (_: IUserInfo) => {},
  setUserProcess: (_: IUserProcess) => {},
};

const GlobalContext = createContext(initialState);

interface IGlobalProvider {
  children?: React.ReactNode;
}

const GlobalProvider: FC<IGlobalProvider> = ({ children }) => {
  const [userInfo, setUserInfo] = useState<IUserInfo>(initialState.userInfo);
  const [userProcess, setUserProcess] = useState<IUserProcess>(initialState.userProcess);

  const contextValue = useMemo(
    () => ({
      userInfo,
      userProcess,
      setUserInfo,
      setUserProcess,
    }),
    [userInfo, userProcess]
  );

  return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>;
};

const useGlobalContext = () => useContext(GlobalContext);

export { GlobalProvider, useGlobalContext };
